'use strict';

window.onerror = function (msg, url, lineNo, columnNo, error) {
  logGaError(msg, url, lineNo, columnNo, error);
};
window.gtm = {
  errors: {
    repeated: false,
  },
  trackIntercard: function (event, element) {
    try {
      event.stopPropagation();
      event.preventDefault();
      window.neptune.clarity('Intercard banner click');
      var version = Array.from(element.classList).find(b => b.indexOf('--') != -1);
      var image = element.querySelector('.image__img')?.src;
      image = image.substr(image.lastIndexOf('/') + 1);
      image = image.split('.')[0];
      var model = {
        event: 'intercard banner click',
        eventModel: {
          type: version,
          click: true,
          target: element.href ?? '',
          image: image,
        },
      };
      window.dataLayer.push(model, () =>
        element.href != null && element.href.length > 5
          ? (window.location.href = element.href)
          : '',
      );
    } catch (e) {
      element.href != null && element.href.length > 5 ? (window.location.href = element.href) : '';
    }
  },
  trackCartRecs: function (event, element) {
    if (element.dataset.addRecommendation != null) {
      var items = '';
      document.querySelectorAll('.cart-drawer .cart-drawer__items-list [data-sku]').forEach(e => {
        items += e.dataset.sku + ',';
      });
      items = items.substring(0, items.length - 1);
      try {
        var model = {
          event: 'cart_recs',
          eventModel: {
            cart_recs_cartid: document.cookie.split('cart=')[1].split(';')[0],
            cart_recs_addsku: element.dataset.sku,
            cart_recs_cart_skus: items,
          },
        };
        window.dataLayer.push(model);
      } catch (e) {
        console.log(e);
      }
    }

    if (element.href != null) {
      try {
        var model = {
          event: 'cart_recs',
          eventModel: {
            cart_recs_cartid: document.cookie.split('cart=')[1].split(';')[0],
            cart_recs_product_view: element.dataset.sku,
          },
        };
        console.log(JSON.stringify(model));
        window.dataLayer.push(model);
      } catch (e) {
        console.log(e);
      }
    }

    if (
      Array.from(element.classList).filter(e => e == 'cart-drawer__recommendations-next').length > 0
    ) {
      try {
        const next = Number(sessionStorage.getItem('cart_recs_next') || 0) + 1;
        sessionStorage.setItem('cart_recs_next', next);
        var model = {
          event: 'cart_recs',
          eventModel: {
            cart_recs_cartid: document.cookie.split('cart=')[1].split(';')[0],
            cart_recs_next: next,
          },
        };
        window.dataLayer.push(model);
      } catch (e) {
        console.log(e);
      }
    }

    if (
      Array.from(element.classList).filter(e => e == 'cart-drawer__recommendations-prev').length > 0
    ) {
      try {
        const prev = Number(sessionStorage.getItem('cart_recs_prev') || 0) + 1;
        sessionStorage.setItem('cart_recs_prev', prev);

        var model = {
          event: 'cart_recs',
          eventModel: {
            cart_recs_cartid: document.cookie.split('cart=')[1].split(';')[0],
            cart_recs_prev: prev,
          },
        };
        window.dataLayer.push(model);
      } catch (e) {
        console.log(e);
      }
    }
  },
  trackDigital: function (element) {
    var name = element.href.substr(element.href.lastIndexOf('/') + 1, element.href.length);
    name = name.indexOf('?') != -1 ? name.split('?')[0] : name;
    name = name.replace(/_/g, ' ');
    var pageType = '';
    try {
      pageType = JSON.parse(document.getElementById('shop-js-analytics').innerHTML).pageType;
    } catch (e) {}
    var model = {
      event: 'digital brochure view',
      eventModel: {
        name: name,
        pageType: pageType,
      },
    };
    window.dataLayer.push(model);
  },
  trackAvailability: function (variant) {
    var model = {
      event: 'variant_availability',
      eventModel: {
        sku: variant.articleId,
        availability: variant.availability,
      },
    };
    window.dataLayer.push(model);
  },
  trackStoreAvailabilityClick: function (element) {
    var action = element.href.indexOf('maps') != -1 ? 'map' : element.href;

    var model = {
      event: 'store_availability',
      eventModel: {
        store_availability_click_type: action,
        store_availability_click_store: element.dataset.storeName,
      },
    };

    window.dataLayer.push(model);
  },
};

function logGaError(msg, url, lineNo, columnNo, error) {
  var data = {};
  data.screenWidth = window.innerWidth;
  data.message = msg;
  if (typeof ga == 'function') {
    var x = {
      event: 'javascript_errors',
      eventData: {
        event_category: 'javascript_errors',
        event_action: window.location.href,
        event_label: JSON.stringify(data),
      },
    };
    window.dataLayer.push(x);
  } else {
    if (window.gtm.errors.repeated == true) {
      return;
    }
    setTimeout(function () {
      logGaError(msg, url, lineNo, columnNo, error);
      window.gtm.errors.repeated = true;
    }, 2000);
  }
}
function observeElement(selector, callback) {
  const element = document.querySelector(selector);
  if (element == null) {
    return;
  }
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          callback();
        }
      });
    },
    {
      root: null,
      threshold: 0.1,
    },
  );
  observer.observe(element);
}
if (sessionStorage.getItem('welcome-popup-seen') == null) {
  var eventSent = false;
  var timer = setInterval(function () {
    var x = document.body.innerHTML.indexOf('Letters from Neptune') != -1;
    if (x && eventSent == false) {
      eventSent = true;
      sessionStorage.setItem('welcome-popup-seen', 'true');
      window.neptune.clarity('welcome popup');
      clearInterval(timer);
    }
  }, 1000);
}
function filterLabels(key, value) {
  var inputs = document.getElementsByTagName('input');
  var matched = null;
  var price = null;
  for (var i = 0; i < inputs.length; i++) {
    var input = inputs[i];
    if (input.name !== key) continue;
    if (input.getAttribute('value') === value) {
      matched = input;
      break;
    }
    if (!price && input.hasAttribute('data-range-input')) price = input;
  }
  var control = matched || price;
  if (!control) return {};
  var labels = {};
  if (control.dataset.filterName) labels.filter_name = control.dataset.filterName;
  if (control.dataset.valueLabel) labels.value_label = control.dataset.valueLabel;
  else if (control.hasAttribute('data-range-input')) {
    var shown = control.getAttribute('value');
    if (shown) labels.value_label = shown;
  }
  return labels;
}

function appliedFilters(search) {
  return [...new URLSearchParams(search).entries()]
    .filter(([key]) => key.startsWith('filter.') || key === 'sort_by')
    .map(function (entry) {
      return Object.assign({ key: entry[0], value: entry[1] }, filterLabels(entry[0], entry[1]));
    });
}

function sameFilter(left, right) {
  return left.key === right.key && left.value === right.value;
}

window.addEventListener('load', function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest(
      '.header__nav a.nav__link, .mega-navigation a[href], .drawer-menu a.drawer-menu__link, .drawer-menu a.drawer-menu__top-level-link',
    );
    if (!link || !link.dataset.linkText) return;
    var href = link.getAttribute('href');
    var item = link.getAttribute('data-item');
    if (!href || href === '#' || item === 'parent' || item === 'back') return;

    var sectionEl = link.closest('[data-nav-section]');
    var section = sectionEl ? sectionEl.dataset.navSection : '';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'navigation_click',
      eventModel: {
        link_url: link.href,
        link_text: link.dataset.linkText,
        nav_section: section,
        nav_department: link.dataset.navDepartment || section,
      },
    });
  });

  document.addEventListener('click', function (event) {
    var card = event.target.closest('a.plpc-bc__card');
    if (!card || !card.closest('[data-section-type="collection-banner"]')) return;
    var slides = Array.from(card.closest('.plpc-bc').querySelectorAll('.carousel-cell'));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'quick_filter_click',
      eventModel: {
        link_url: card.href,
        link_text: card.dataset.linkText || '',
        position: slides.indexOf(card.closest('.carousel-cell')) + 1,
      },
    });
  });

  var previousFilters = appliedFilters(window.location.search);
  function pushFilterDelta() {
    var next = appliedFilters(window.location.search);
    var added = next.filter(function (pair) {
      return !previousFilters.some(function (old) {
        return sameFilter(old, pair);
      });
    });
    var removed = previousFilters.filter(function (pair) {
      return !next.some(function (current) {
        return sameFilter(current, pair);
      });
    });
    if (added.length || removed.length) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'filter_change',
        eventModel: {
          added: added,
          removed: removed,
        },
      });
    }
    previousFilters = next;
  }
  document.addEventListener('theme:collection:updated', pushFilterDelta);
  window.addEventListener('popstate', pushFilterDelta);

  if (window.shopify_product != null) {
    var hasCylindo = window.shopify_product.filter(e => e.default_cylindo_id != '').length != 0;
    try {
      if (this.document.querySelector('.product-form__chip-wrapper') != null) {
        observeElement('.product-form__chip-wrapper', () => {
          var model = {
            event: 'lozenges view',
            eventModel: {
              lozenges_viewdata: document
                .querySelector('.product-form__chip-wrapper')
                .innerText.split('\n')
                .toString(),
            },
          };
          window.dataLayer.push(model);
          this.document.querySelectorAll('.product-form__chip').forEach(button => {
            button.addEventListener('click', () => {
              var model2 = {
                event: 'lozenges click',
                eventModel: {
                  lozenges_click: button.innerText,
                },
              };
              window.dataLayer.push(model2);
            });
          });
        });
      }
    } catch (ex) {}
    if (hasCylindo) {
      var qq = setInterval(function () {
        var events = window.dataLayer.filter(e => e.event == 'cylindoGA4Event');
        events.forEach(e => {
          if (e.viewer_engagement_type != null) {
            if (e.clarity == null) {
              e.clarity = true;
              window.neptune.clarity(
                `Cylindo interaction ${e.viewer_engagement_type.toLowerCase().trim()}`,
              );
            }
          }
        });
      }, 2000);
    }
  }
  var sliderBtns = document.querySelectorAll('.collection__container .product-item  .slider-btn');
  if (sliderBtns.length > 0) {
    sliderBtns.forEach(e => {
      e.addEventListener('click', r => {
        window.neptune.clarity('collection product slider interaction');
      });
    });
  }
});
